"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINToggleInput = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var PINOption_1 = require("./PINOption");
var PINInput_1 = require("./PINInput");
var PINToggleInput = /** @class */ (function (_super) {
    __extends(PINToggleInput, _super);
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
    function PINToggleInput(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            error: null,
            value: (_this.props.radio
                ? _this.props.value || _this.props.defaultValue || undefined
                : __spreadArrays((_this.props.value || _this.props.defaultValue || [])))
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
        _this.computeSections = function (props) {
            /* Let parent decide to use either sections or flat options */
            if (props.options || props.children) {
                return [{
                        value: "solo-section",
                        options: PINOption_1.retrieveOptions(props.children, props.options)
                    }];
            }
            // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'section' implicitly has an 'any' type.
            return (props.sections || []).map(function (section) { return (__assign(__assign({}, section), { options: PINOption_1.retrieveOptions(null, section.options) })); });
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        _this.getValueOnChange = function (event, complement) {
            if (_this.props.radio) {
                _this.setState({ value: event.target.value });
                return event.target.value;
            }
            var value = __spreadArrays(_this.state.value);
            var isChecked = value.indexOf(complement) >= 0;
            if (isChecked) {
                value = value.filter(function (item) { return (item !== complement); });
            }
            else {
                value.push(complement);
            }
            _this.setState({ value: value });
            return value;
        };
        _this.sections = _this.computeSections(props);
        return _this;
    }
    PINToggleInput.prototype.componentDidMount = function () {
        this.sections = this.computeSections(this.props);
    };
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
    PINToggleInput.prototype.componentWillReceiveProps = function (props) {
        this.sections = this.computeSections(props);
    };
    // @ts-expect-error ts-migrate(2416) FIXME: Property 'render' in type 'PINToggleInput' is not ... Remove this comment to see the full error message
    PINToggleInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, required = _a.required, hiddenRequired = _a.hiddenRequired, label = _a.label, name = _a.name, id = _a.id;
        var inputProps = {
            type: this.props.radio ? "radio" : "checkbox"
        };
        return (React.createElement("div", { className: "pintoggle " + (this.props.className ? this.props.className : "") },
            React.createElement("div", { className: "pintoggle-label" },
                (required && !hiddenRequired) && "* ",
                label || ""),
            this.sections.map(function (section, sectionIndex) { return (React.createElement("div", { className: "mb-md", key: section.value + "-" + sectionIndex },
                section.label ? React.createElement("div", { className: "pintoggle-section-label" }, section.label) : null,
                section.options.map(function (option, index) { return (React.createElement("div", { key: option.value + "-" + index, className: "d-flex justify-content-between mb-xs" },
                    React.createElement("div", { className: "pintoggle-option-label" }, option.label),
                    React.createElement("label", { className: "switch" },
                        React.createElement("input", __assign({}, inputProps, { id: (id || name) + index, onChange: function (e) { return (_this.onChange(e, option.value)); }, name: name, value: option.value, checked: _this.props.radio
                                ? _this.state.value === option.value
                                : _this.state.value.includes(option.value), readOnly: true })),
                        React.createElement("span", { className: "slider round" })))); }))); })));
    };
    PINToggleInput.className = "PINToggleInput";
    PINToggleInput.propTypes = __assign(__assign({}, PINInput_1.PINInput.propTypes), { options: PropTypes.arrayOf(PropTypes.shape(PINOption_1.PINOption.propTypes)), sections: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string,
            options: PropTypes.arrayOf(PropTypes.shape(PINOption_1.PINOption.propTypes))
        })), radio: PropTypes.bool });
    return PINToggleInput;
}(PINInput_1.PINInput));
exports.PINToggleInput = PINToggleInput;
//# sourceMappingURL=PINToggleInput.js.map